/* globals Routes */

import cx from "classnames";
import { CTA } from "common/styleguide/CTA";
import { Sidebar } from "features/recumbent/PlannerSidebar/LegacySidebar";
import { commonVerbs, Msg } from "lib/localization";
import React from "react";
import { FormattedMessage as T } from "react-intl";
import { CueForm } from "./CueForm";
import styles from "./RightSidebar.scss";

class ReviewFinished extends React.PureComponent {
  save = () => {
    const { onBeforeSave, onReturn, onSave } = this.props;
    onBeforeSave && onBeforeSave();

    onReturn();
    onSave
      ? onSave() // new planner
      : Routes.New.saveRoute(); // old planner
  };

  render() {
    const { cues, onReturn, onDismiss } = this.props;

    return (
      <div>
        <h2>
          <T id="RightSidebar.reviewCompleteTitle" defaultMessage="Review Complete!" />
        </h2>
        <div>
          <T
            id="RightSidebar.reviewComplete"
            defaultMessage="Your review is complete! Save your route, or return the editor."
          />
        </div>
        <CTA style={{ marginBottom: "10px" }} onClick={onReturn}>
          <T id="RightSidebar.returnToRoutePlanner" defaultMessage="Return to Route Planner" />
        </CTA>
        <CTA style={{ marginTop: 0, marginBottom: "10px" }} secondary onClick={this.save}>
          <Msg m={commonVerbs.save} />
        </CTA>
        <CTA style={{ marginTop: 0 }} secondary onClick={() => !!cues.size && onDismiss()} disabled={!cues.size}>
          <T id="RightSidebar.keepReviewing" defaultMessage="Keep Reviewing" />
        </CTA>
      </div>
    );
  }
}

export class RightSidebar extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      finishedDismissed: props.cues.every((c) => c.confirmed),
    };
  }

  dismissReviewFinished = () => {
    this.setState({
      finishedDismissed: true,
    });
  };

  render() {
    const { cues, currentCue, onClose, onConfirm, onPrevious, onSave, onDelete, removeCues, className } = this.props;

    const sidebarProps = Routes.New.mapCommand;
    const smallSidebarProps = {
      setCallbacks: {
        createPoi: sidebarProps.setCallbacks.createPoi,
        addCue: sidebarProps.setCallbacks.addCue,
      },
      unsetCallbacks: sidebarProps.unsetCallbacks,
      selectedCommand: "addCue",
    };

    const reviewFinished = !this.state.finishedDismissed && cues.every((c) => c.confirmed === true);

    return (
      <div className={cx(styles.RightSidebar, className)}>
        <div onClick={onClose} className={styles.returnToPlanner}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.41 7.41L14 6L8 12L14 18L15.41 16.59L10.83 12L15.41 7.41Z" fill="black" fillOpacity="0.54" />
          </svg>
          <T id="RightSidebar.returnToPlanner" defaultMessage="Return to the Route Planner" />
        </div>
        <div className={styles.header}>
          <T id="RightSidebar.reviewCue" defaultMessage="Review Cue" />
        </div>
        <div className={styles.scrollContainer}>
          <div className={styles.topHalf}>
            {!reviewFinished && (
              <CueForm currentCue={currentCue} onConfirm={onConfirm} onPrevious={onPrevious} onDelete={onDelete} />
            )}
            {reviewFinished && (
              <ReviewFinished
                cues={cues}
                onBeforeSave={removeCues}
                onSave={onSave}
                onReturn={onClose}
                onDismiss={this.dismissReviewFinished}
              />
            )}
          </div>
          {!reviewFinished && (
            <div className={styles.bottomHalf}>
              <Sidebar showRouteOptions={false} {...smallSidebarProps} />
              <T id="RightSidebar.returnToEditor" defaultMessage="Return to the route editor for full edit options." />
              <CTA onClick={onClose}>
                <T id="RightSidebar.closeReview" defaultMessage="Close Review" />
              </CTA>
            </div>
          )}
        </div>
      </div>
    );
  }
}
